/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, WebAppGetFragmentSocialUploadsByFragmentIdPathParams } from "../models/WebAppGetFragmentSocialUploadsByFragmentId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetFragmentSocialUploadsByFragmentId } from "../axios/webAppGetFragmentSocialUploadsByFragmentId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetFragmentSocialUploadsByFragmentIdQueryKey = (fragmentId: WebAppGetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"]) => ["api-v2", { url: '/web-app/fragment-social-uploads/by-fragment/:fragmentId', params: {fragmentId:fragmentId} }] as const

export type WebAppGetFragmentSocialUploadsByFragmentIdQueryKey = ReturnType<typeof webAppGetFragmentSocialUploadsByFragmentIdQueryKey>

export function webAppGetFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId: WebAppGetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetFragmentSocialUploadsByFragmentIdQueryKey(fragmentId)
        return queryOptions<WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, ResponseErrorConfig<Error>, WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, typeof queryKey>({
         enabled: !!(fragmentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetFragmentSocialUploadsByFragmentId(fragmentId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get social uploads for a fragment
 * {@link /web-app/fragment-social-uploads/by-fragment/:fragmentId}
 */
export function useWebAppGetFragmentSocialUploadsByFragmentId<TData = WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, TQueryData = WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, TQueryKey extends QueryKey = WebAppGetFragmentSocialUploadsByFragmentIdQueryKey>(fragmentId: WebAppGetFragmentSocialUploadsByFragmentIdPathParams["fragmentId"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetFragmentSocialUploadsByFragmentIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetFragmentSocialUploadsByFragmentIdQueryKey(fragmentId)
         

         const query = useQuery({
          ...webAppGetFragmentSocialUploadsByFragmentIdQueryOptions(fragmentId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}